<template>
  <div style="margin: auto">
    <box-component :mt="24">
      <button class="btn btn-primary" @click="handleDownload">Download</button>
    </box-component>
  </div>
  <slot></slot>
</template>

<script>
import httpClient from '../api/httpClient'
import { BoxComponent } from '@/ui-library'

export default {
  components: { BoxComponent },
  props: {
    action: {
      required: true,
      type: String,
    },
  },
  methods: {
    async handleDownload() {
      try {
        const url = new URL(this.action)
        const endpoint = url.pathname + url.search

        const response = await httpClient.post(
          endpoint,
          {},
          {
            responseType: 'blob',
          },
        )

        const contentType = response.headers['content-type']
        const extension = contentType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ? 'xlsx' : 'xls'

        const downloadUrl = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = downloadUrl
        link.setAttribute('download', this.getFileName(endpoint, extension))
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(downloadUrl)
      } catch (error) {
        console.error(error)
      }
    },
    getFileName(endpoint, extension = 'xls') {
      const parts = endpoint.split('/')
      const lastPart = parts[parts.length - 1]
      const baseName = lastPart.split('?')[0]
      const today = new Date().toISOString().split('T')[0]
      return `${baseName}-${today}.${extension}`
    },
  },
}
</script>
